import React from 'react';
import { Link } from 'react-router-dom';
import OptimizedImage from './OptimizedImage';
import { IMAGE_BLURS } from '../data/imageBlurs';

const ManifestoSection: React.FC = () => {
  return (
    <section
      id="value-prop"
      className="relative w-full min-h-screen flex flex-col justify-center bg-canvas border-0 outline-none py-24 md:py-32"
      aria-labelledby="value-prop-heading"
    >
      {/* Background Layer */}
      <div className="absolute inset-0 bg-canvas z-0" aria-hidden="true"></div>

      <div className="relative z-10 w-full px-6 md:px-24 lg:px-32 flex flex-col md:flex-row items-center gap-12 md:gap-16">
        {/* Text Area */}
        <div className="flex-1">
          <h2
            id="value-prop-heading"
            className="text-5xl md:text-7xl lg:text-8xl font-normal tracking-[-0.02em] text-text-primary mb-6 md:mb-8 leading-[1.1]"
          >
            Return to clarity
          </h2>

          <p className="text-lg md:text-xl text-text-primary leading-relaxed text-balance max-w-2xl">
            Nura is an adaptive meditation engine that meets your mind exactly where it is. Explore how it works.
          </p>
          <Link
            to="/technology"
            className="mt-6 md:mt-8 inline-block text-lg text-text-primary whitespace-nowrap bg-transparent border border-primary px-5 py-2 rounded-full hover:bg-text-primary hover:text-canvas transition-colors focus-visible:outline-2 focus-visible:outline-text-primary focus-visible:outline-offset-4 focus:outline-none"
          >
            How it works
          </Link>
        </div>

        {/* Image */}
        <div
          className="relative w-[100vw] md:w-full md:max-w-[600px] -mx-6 md:mx-0 aspect-square flex-shrink-0 rounded-none md:rounded-2xl overflow-hidden isolate"
          style={{ transform: 'translateZ(0)', WebkitMaskImage: '-webkit-radial-gradient(white, black)' }}
        >
          <OptimizedImage
            src="/images/app_mockup.webp"
            mobileSrc="/images/app_mockup-mobile.webp"
            blurSrc={IMAGE_BLURS.app_mockup}
            alt="Nura app interface"
            containerClassName="w-full h-full"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default ManifestoSection;
